module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasError) ? _c('PageError') : _c('BreadcrumbsLayout', {
    attrs: {
      "bg": "#ededed",
      "breadcrumbs": _vm.breadcrumbsExtended
    }
  }, [_c('CatalogList', {
    attrs: {
      "constrain-name-height": false,
      "items": _vm.activities,
      "doubler": false,
      "title": "",
      "use-padding": false
    }
  }, [_c('FlexCenter', {
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, [_c('CalendarDay', {
    attrs: {
      "count": _vm.count,
      "next": _vm.next,
      "prev": _vm.prev,
      "value": _vm.date,
      "completed": _vm.isCompleted
    }
  }), _c('br'), _c('br'), _c('CalendarLink', {
    attrs: {
      "to": _vm.calendar
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1)], 1), _c('PaginationLayout', [(_vm.pagesCount > 1) ? _c('ActivitesPaginator', {
    attrs: {
      "slot": "paginator",
      "count": _vm.pagesCount,
      "current": _vm.page,
      "max": 6
    },
    slot: "paginator"
  }) : _vm._e(), _c('SelectCount', {
    attrs: {
      "slot": "count",
      "options": _vm.pageLimits,
      "value": _vm.pageLimit,
      "text": _vm.byPageText
    },
    on: {
      "change": _vm.pageLimitChange
    },
    slot: "count"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a6564c","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activities/day/component.vue
// module id = 7b10386fd6f5ef717629
// module chunks = 13